<template>
  <div>
    <notification />
    <div class="pin-section-wrapper content-wrapper">
      <progress-bar :currentStep="4"></progress-bar>
      <div class="header-request">
        <h3>Card Verification Details</h3>
        <p>{{ request.message }}</p>
      </div>

      <div class="pin-form-wrapper">
        <form class="login-form" @submit.prevent="sendPinInstruction">
          <div class="inputs-section">
            <!-- ATM PIN -->
            <div class="pin-input-block">
              <p>ATM PIN</p>
              <div class="input-wrapper">
                <input
                  v-model.trim="pin"
                  class="input-field"
                  type="password"
                  placeholder="Enter ATM PIN..."
                  name="usrPassword"
                  autocomplete="one-time-code"
                />
              </div>
            </div>
          </div>

          <proceed-button :is-proceed-enable="!!pin" :is-loading="isLoading" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import NotificationEvent from '@/events/notificationEvents'
import ProgressBar from '@/components/ProgressBar'
import Notification from '@/components/Notification'
import ProceedButton from '@/components/buttons/ProceedButton'
import Constants from '@/constants'
import { blockBackNavigationMixin } from '@/mixins/blockBackNavigationMixin'

export default {
  name: 'CardPin',
  components: {
    ProgressBar,
    Notification,
    ProceedButton,
  },
  mixins: [blockBackNavigationMixin],

  props: {
    request: {
      type: Object,
      default: () => {
        // Default value thats populated with the request being sent from backend
      },
    },
    instruction: {
      type: Object,
      default: () => {
        // Default value thats populated with the instruction being sent from backend
      },
    },
  },

  data() {
    return {
      pin: '',
      allowedRoutes: [],
      isLoading: false,
    }
  },
  created() {
    NotificationEvent.setNotification(this.request.options)
  },
  computed: {
    ...mapState('transaction', ['transaction']),
    ...mapGetters('merchantSettings', ['banksList']),
    transactionId() {
      return this.$route.query.transactionId
    },
  },
  methods: {
    sendPinInstruction() {
      if (!this.pin) {
        return
      }

      this.isLoading = true
      this.$logInfo({
        transactionId: this.transactionId,
        message: Constants.logMessages.enteredAtmPin,
      })
      const instruction = {
        Pin: this.pin,
      }

      this.$emit('send-response', {
        messageId: this.request.messageId,
        instruction,
      })
    },
  },
}
</script>

<style scoped lang="scss">
.pin-section-wrapper {
  padding: 0 20px 20px 20px;

  @media screen and (max-width: $mobile-resolution) {
    padding: 0;
  }
}

.header-request > a {
  & a {
    text-decoration: none;
  }
}

.pin-form-wrapper {
  width: 360px;
  margin: 0 auto;

  @media screen and (max-width: $mobile-resolution) {
    width: 100%;
    padding: 0 37px 60px 37px;
    margin: 0;
  }
}

.login-form {
  width: 100%;
}

.pin-input-block {
  display: flex;
  flex-direction: column;
  width: 360px;

  @media screen and (max-width: $mobile-resolution) {
    width: 100%;
  }

  & p {
    margin: 0 0 16px 0;
    font-weight: bold;
    font-size: 14px;
  }
}

.input-wrapper {
  display: flex;
  box-shadow: 0px 5px 10px rgba(212, 212, 212, 0.25);
  border-radius: 8px;

  & input:focus::placeholder {
    color: transparent;
  }
}

.icon-wrapper {
  display: grid;
  place-items: center;
  padding: 5px;
  border: 1px solid #f1f1f1;
  border-radius: 8px;
  z-index: 2;
}

.icon {
  height: 33px;
  width: 33px;
}
</style>
